import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { BrandMarquee } from "@/components/site/BrandMarquee";
import { SearchInventory } from "@/components/site/SearchInventory";
import { Manifesto } from "@/components/site/Manifesto";
import { Promotions } from "@/components/site/Promotions";
import { Wholesale } from "@/components/site/Wholesale";
import { Reviews } from "@/components/site/Reviews";
import { Location } from "@/components/site/Location";
import { Footer } from "@/components/site/Footer";
import { FloatingButtons } from "@/components/site/FloatingButtons";

export default function SiteHome() {
  return (
    <div className="grain">
      <Navbar />
      <main>
        <Hero />
        <BrandMarquee />
        <SearchInventory />
        <Manifesto />
        <Promotions />
        <Wholesale />
        <Reviews />
        <Location />
      </main>
      <Footer />
      <FloatingButtons />
    </div>
  );
}
